// Individual modules
var bravo = bravo || {};
bravo.utilities = (function () {
	'use strict';

	// Returns a function, that, as long as it continues to be invoked, will not
	// be triggered. The function will be called after it stops being called for
	// N milliseconds. If `immediate` is passed, trigger the function on the
	// leading edge, instead of the trailing.
	const debounce = (func, wait, immediate) => {
		let timeout;

		return () => {
			let context = this,
				args = arguments;
			const later = () => {
				timeout = null;
				if (!immediate) {
					func.apply(context, args);
				}
			};
			let callNow = immediate && !timeout;
			clearTimeout(timeout);
			timeout = setTimeout(later, wait);
			if (callNow) {
				func.apply(context, args);
			}
		};
	};

	const getScrollbarWidth = () => {
		//https://stackoverflow.com/a/13382873

		// Creating invisible container
		const outer = document.createElement('div');
		outer.style.visibility = 'hidden';
		outer.style.overflow = 'scroll'; // forcing scrollbar to appear
		outer.style.msOverflowStyle = 'scrollbar'; // needed for WinJS apps
		document.body.appendChild(outer);

		// Creating inner element and placing it in the container
		const inner = document.createElement('div');
		outer.appendChild(inner);

		// Calculating difference between container's full width and the child width
		const scrollbarWidth = outer.offsetWidth - inner.offsetWidth;

		// Removing temporary elements from the DOM
		outer.parentNode.removeChild(outer);

		document.documentElement.style.setProperty(
			'--scrollbar-width',
			(document.body.scrollHeight > window.innerHeight ? scrollbarWidth : 0) + 'px'
		);

		return scrollbarWidth;
	};

	return {
		debounce: debounce,
		getScrollbarWidth: getScrollbarWidth
	};
})();
/* globals Swup, SwupBodyClassPlugin, SwupScrollPlugin, swupInst */

bravo.swup = (function () {
	'use strict';

	let popTimer;
	let nativePop = false;

	const initialize = () => {
		nativePop = false;

		// fallback for error pages when swup does not fire properly
		window.addEventListener('popstate', function () {
			popTimer = setTimeout(function () {
				nativePop = true;
				document.documentElement.classList.remove('from-timeline-to-content');
				document.documentElement.classList.remove('from-content-to-timeline');
				document.documentElement.classList.remove('loading-content');
				document.documentElement.classList.remove('is-changing');
				document.documentElement.classList.remove('is-leaving');
				document.documentElement.classList.remove('is-animating');
			}, 500);
		});

		window.swupInst = new Swup({
			plugins: [
				new SwupBodyClassPlugin({
					prefix: ''
				}),
				new SwupScrollPlugin({
					doScrollingRightAway: false,
					animateScroll: true,
					scrollFriction: 0.3,
					scrollAcceleration: 0.15
				})
			],
			animationSelector: '[class*="swup-transition"]',
			animateHistoryBrowsing: true,
			cache: false
		});

		swupInst.on('popState', () => {
			clearTimeout(popTimer);
			nativePop = false;
			window.timelineAllowHistory = true;
		});

		swupInst.on('willReplaceContent', () => {
			bravo.scripts.unInit();
			swupInst.scrollTo(document.body, 0);
		});

		swupInst.on('contentReplaced', () => {
			bravo.scripts.swupReInit();
		});

		swupInst.on('animationOutStart', () => {
			document.documentElement.classList.remove('from-timeline-to-content');
			document.documentElement.classList.remove('from-content-to-timeline');

			if (swupInst.transition && swupInst.transition.from) {
				const { from: pageFrom, to: pageTo } = swupInst.transition;

				if (pageTo.indexOf('/timeline') !== -1) {
					if (
						pageFrom.indexOf('/timeline') !== -1 || // bug with swup
						pageFrom.indexOf('/people') !== -1 ||
						pageFrom.indexOf('/stories') !== -1 ||
						pageFrom.indexOf('/shows') !== -1
					) {
						document.documentElement.classList.add('from-content-to-timeline');
					}
				} else if (pageFrom.indexOf('/timeline') !== -1) {
					document.documentElement.classList.add('from-timeline-to-content');
				}
			}
		});

		swupInst.on('animationOutDone', () => {
			if (!nativePop) {
				document.documentElement.classList.add('loading-content');
			}

			nativePop = false;
		});

		swupInst.on('animationInStart', () => {
			document.documentElement.classList.remove('loading-content');
		});
	};

	return {
		init: initialize
	};
})();
/* globals Cookies */

bravo.welcome = (function () {
	'use strict';

	let welcomePage;
	let welcomeMessage;
	let continueButton;

	const finish = (delay = true) => {
		Cookies.set('acknowledgementViewed', true, { expires: 30 });

		welcomeMessage.classList.remove('active');

		setTimeout(
			() => {
				bravo.warning.check();
			},
			delay ? 1500 : 0
		);
	};

	const start = () => {
		welcomeMessage.classList.add('active');

		continueButton.addEventListener('click', () => {
			finish();
		});
	};

	const check = () => {
		if (!welcomeMessage) {
			bravo.warning.check();
			return;
		}

		if (Cookies.get('acknowledgementViewed')) {
			finish(false);
		} else {
			start();
		}
	};

	const initialize = () => {
		welcomePage = document.querySelector('.welcome');
		welcomeMessage = document.querySelector('.welcome-message');
		continueButton = document.querySelector('.welcome-message button');

		if (!welcomePage) {
			return;
		}

		document.body.classList.add('menu-hidden');

		check();
	};

	return {
		init: initialize
	};
})();
/* globals Cookies */

bravo.warning = (function () {
	'use strict';

	let warningPage;
	let warningMessage;
	let continueButton;

	const finish = (delay = true) => {
		Cookies.set('warningViewed', true, { expires: 30 });

		warningMessage.classList.remove('active');

		setTimeout(
			() => {
				bravo.intro.start();
			},
			delay ? 1500 : 0
		);
	};

	const start = () => {
		warningMessage.classList.add('active');

		continueButton.addEventListener('click', () => {
			finish();
		});
	};

	const check = () => {
		if (!warningMessage) {
			bravo.intro.start();
			return;
		}

		if (Cookies.get('warningViewed')) {
			finish(false);
		} else {
			start();
		}
	};

	const initialize = () => {
		warningPage = document.querySelector('.welcome');
		warningMessage = document.querySelector('.warning-message');
		continueButton = document.querySelector('.warning-message button');

		if (!warningPage) {
			return;
		}

		document.body.classList.add('menu-hidden');
	};

	return {
		init: initialize,
		check: check
	};
})();
/* globals Swiper, swupInst */

bravo.intro = (function () {
	'use strict';

	let introSwiper;
	let swiperContainer;
	let swiperEl;
	let skipButton;

	const finish = () => {
		introSwiper.autoplay = false;

		setTimeout(function () {
			if (swupInst) {
				swupInst.loadPage({ url: skipButton.href.replace(window.location.origin, '') });
			} else {
				window.location.href = skipButton.href;
			}
		}, 2000);
	};

	const start = () => {
		swiperContainer.classList.add('active');
		skipButton.classList.add('active');

		introSwiper.autoplay.start();
	};

	const initialize = () => {
		swiperContainer = document.querySelector('.intro-swiper');
		swiperEl = document.querySelector('.intro-swiper .swiper');
		skipButton = document.querySelector('.intro-swiper .skip-button');

		if (!swiperContainer) {
			return;
		}

		introSwiper = new Swiper(swiperEl, {
			speed: 0,
			spaceBetween: 0,
			loop: false,
			centeredSlides: true,
			autoplay: {
				delay: 3000,
				disableOnInteraction: false
			},
			stopOnLastSlide: true,
			effect: 'fade',
			on: {
				slideChangeTransitionStart: function () {
					if (introSwiper) {
						const textEl = introSwiper.slides[introSwiper.realIndex].querySelector('.intro-text');

						if (textEl) {
							const currentColor = textEl.computedStyleMap().get('color').toString();
							skipButton.style.color = currentColor;
						}
					}
				},
				reachEnd: function () {
					finish();
				}
			}
		});

		introSwiper.autoplay.stop();
	};

	const unInitialize = () => {
		if (introSwiper) {
			introSwiper.autoplay = false;
			introSwiper.detachEvents();
			// introSwiper.destroy(true, true);
			introSwiper = null;
		}
	};

	return {
		init: initialize,
		unInit: unInitialize,
		start: start
	};
})();
/* globals Swiper */

bravo.timeline = (function () {
	'use strict';

	const themeParent = document.querySelector('body');
	let timelineInst;
	let timelineControllerInst;
	let currentEra;
	let slideManifest;
	let rafInProgress;

	const initialize = () => {
		currentEra = ''; //'discover';
		slideManifest = {};
		rafInProgress = false;

		[...document.querySelectorAll('.timeline-swiper .swiper-slide')].forEach((slide, i) => {
			const era = slide.dataset.name;

			if (!slideManifest[era]) {
				slideManifest[era] = {
					name: era,
					startIndex: i,
					slideCount: 0,
					controllerEl: null,
					progressEl: null,
					controllerIndex: 0
				};
			}

			const slideAnchor = slide.querySelector('a');

			if (slideAnchor) {
				slideAnchor.addEventListener('click', function () {
					window.timelinePrevSlideIndex = i;
				});
			}

			slideManifest[era].slideCount += 1;
		});

		[...document.querySelectorAll('.timeline-controller-swiper .swiper-slide')].forEach((slide, i) => {
			const era = slide.dataset.name;

			if (slideManifest[era]) {
				slideManifest[era].controllerEl = slide;
				slideManifest[era].progressEl = slide.querySelector('.progress-position');
				slideManifest[era].controllerIndex = i;
			}

			slide.addEventListener('click', function () {
				timelineInst.slideTo(slideManifest[era].startIndex);
			});
		});

		timelineControllerInst = new Swiper('.timeline-controller-swiper', {
			centerInsufficientSlides: true,
			centeredSlides: true,
			centeredSlidesBounds: true,
			slidesPerView: 'auto',
			spaceBetween: 0,
			freeMode: true,
			grabCursor: true
		});

		timelineInst = new Swiper('.timeline-swiper', {
			autoplay: false,
			centerInsufficientSlides: true,
			centeredSlides: true,
			centeredSlidesBounds: true,
			slidesPerView: 'auto',
			spaceBetween: 0,
			freeMode: true,
			mousewheel: {
				enabled: true,
				sensitivity: 2
			},
			preloadImages: false,
			resizeObserver: false,
			preventClicks: true,
			preventClicksPropagation: true,
			initialSlide: window.timelineAllowHistory && window.timelinePrevSlideIndex ? window.timelinePrevSlideIndex : 0,
			grabCursor: true,
			on: {
				afterInit: function () {
					window.timelineAllowHistory = false;
				},
				slideChange: function () {
					if (!rafInProgress) {
						rafInProgress = true;

						window.requestAnimationFrame(() => {
							const previousEra = currentEra;
							const thisEra = this.slides[this.activeIndex].dataset.name;

							if (thisEra !== previousEra) {
								currentEra = thisEra;

								const currentActiveThemeClasses = [...themeParent.classList].filter((c) => c.includes('theme-'));
								currentActiveThemeClasses.forEach((c) => themeParent.classList.remove(c));
								themeParent.classList.add('theme-' + thisEra);

								Object.keys(slideManifest).forEach((i) => {
									if (slideManifest[i].name !== thisEra) {
										slideManifest[i].controllerEl.classList.remove('active');
									}
								});

								slideManifest[thisEra].controllerEl.classList.add('active');

								if (previousEra) {
									if (slideManifest[thisEra].startIndex > slideManifest[previousEra].startIndex) {
										slideManifest[previousEra].progressEl.style.width = '100%';
									} else {
										slideManifest[previousEra].progressEl.style.width = '0%';
									}
								}

								if (window.innerWidth < 1200) {
									timelineControllerInst.slideTo(slideManifest[thisEra].controllerIndex);
								}
							}

							const eraProgress =
								(this.activeIndex - slideManifest[thisEra].startIndex + 1) / slideManifest[thisEra].slideCount;
							slideManifest[thisEra].progressEl.style.width = eraProgress * 100 + '%';

							rafInProgress = false;
						});
					}
				}
			}
		});
	};

	const unInitialize = () => {
		if (timelineInst) {
			// timelineInst.detachEvents();
			// timelineInst.destroy(true, true);
			timelineInst = null;
		}
		if (timelineControllerInst) {
			// timelineControllerInst.detachEvents();
			// timelineControllerInst.destroy(true, true);
			timelineControllerInst = null;
		}
	};

	return {
		init: initialize,
		unInit: unInitialize
	};
})();
/* jshint unused:false */
/* globals Swiper, swupInst */

bravo.components = (function () {
	'use strict';

	const initialize = () => {
		var textSlider = new Swiper('.text-slider-container', {
			slidesPerView: 1,
			spaceBetween: 30,
			loop: true
		});

		var clickSlider = new Swiper('.click-slider-container', {
			slidesPerView: 1,
			spaceBetween: 100,
			loop: true,
			pagination: {
				el: '.swiper-pagination',
				type: 'fraction'
			},
			navigation: {
				nextEl: '.slider-control-next-arrow',
				prevEl: '.slider-control-prev-arrow'
			},
			controller: {
				control: textSlider
			},
			on: {
				slideChange: function () {
					var currentSlide = this.realIndex + 1;
					this.el.querySelector('.slider-active-slide').innerHTML = currentSlide;
				},
				init: function () {
					var totalSlides = this.slides.length - this.loopedSlides * 2;
					this.el.querySelector('.slider-total-slide').innerHTML = totalSlides;

					if (totalSlides === 1) {
						this.disable();
					}
				}
			}
		});

		var dragSlider = new Swiper('.drag-slider-container', {
			slidesPerView: 'auto',
			spaceBetween: 30,
			freeMode: true,
			mousewheel: {
				enabled: true,
				sensitivity: 1
			},
			grabCursor: true
		});

		const backButton = document.querySelector('.component-back-button');

		if (backButton) {
			backButton.addEventListener('click', function (e) {
				e.preventDefault();

				if (swupInst && swupInst.transition && swupInst.transition.from) {
					window.history.back();
				} else {
					swupInst.loadPage({ url: backButton.href.replace(window.location.origin, '') });
				}
			});
		}
	};

	return {
		init: initialize
	};
})();
/* globals Vue, VirtualList, fetch */

bravo.menu = (function () {
	'use strict';

	let jsMenuLinks;
	let linkFilters;
	let menuButton;
	let closeButton;
	let menuInst;
	let menuEl;
	let navLogo;

	const formatDate = (date) => {
		const day = date.toLocaleString('default', { day: '2-digit' });
		const month = date.toLocaleString('default', { month: 'short' });
		const year = date.toLocaleString('default', { year: 'numeric' });
		return day + ' ' + month + ' ' + year;
	};

	const openMenuOverlay = (e) => {
		if (e) {
			e.preventDefault();
		}

		$('body').addClass('menu-open');
		menuEl.fadeIn(500);

		bravo.search.doClose();
	};

	const closeMenuOverlay = () => {
		menuEl.fadeOut(500);
		$('body').removeClass('menu-open');
	};

	const initializeJs = () => {
		menuEl = $('#menu');
		menuButton = $('.navbar-menu .hamburger-icon');
		closeButton = $('.navbar-menu .close-icon');
		jsMenuLinks = $('.menu-overlay .js-menu-links');
		linkFilters = $('.menu-overlay .links-filter');
		navLogo = $('.navbar-logo');

		if (!menuButton) {
			return;
		}

		menuButton.on('click', openMenuOverlay);

		closeButton.on('click', closeMenuOverlay);

		navLogo.on('click', closeMenuOverlay);

		jsMenuLinks.each(function () {
			const link = $(this);
			link.on('click', function () {
				linkFilters.removeClass('active');

				const linkParent = link.closest('.sidebar-links-main-content');

				linkParent.addClass('active');
				linkParent.find('.links-filter').eq(0).addClass('active');
				linkParent.siblings('.sidebar-links-main-content').removeClass('active');

				const currentContent = $('.menu-overlay .page-menu-content.active');
				const nextContent = $(link.data('target'));
				currentContent.removeClass('active');
				nextContent.addClass('active');
			});
		});

		linkFilters.each(function () {
			const filter = $(this);
			filter.on('click', function () {
				filter.addClass('active').siblings('.links-filter').removeClass('active');
			});
		});
	};

	const initialiseVue = () => {
		var MenuShowsByName = {
			name: 'MenuShowsByName',
			template: `
			<div class="menu-content-letter">
				<h4 v-if="source.sectionTitle && source.sectionTitle !== 'null'" class="h3 content-letter-main theme-color">{{source.sectionTitle}}</h4>
				<div v-if="source.entries && source.entries.length" class="content-letter-list">
					<a v-on:click="close" v-for="entry in source.entries" class="list-link" v-bind:href="entry.url">
						<span class="list-link-name theme-background">
							{{entry.title}}
							<span class="list-link-img-wrapper">
								<span class="list-link-img theme-loading-gradient" v-if="entry.imageCropMedium || entry.imageCropSmall">
									<picture>
										<img v-bind:src="entry.imageCropSmall" v-bind:alt="entry.title" />
									</picture>
								</span>
							</span>
						</span>
					</a>
				</div>
			</div>
			`,
			props: ['index', 'source', 'close']
		};

		var MenuShowsByYear = {
			name: 'MenuShowsByYear',
			template: `
			<div class="menu-content-letter">
				<h4 v-if="source.sectionTitle && source.sectionTitle !== 'null'" class="h3 content-letter-main theme-color" v-bind:class="'theme-' + source.era">{{source.sectionTitle}}</h4>
				<div v-if="source.entries && source.entries.length" class="content-letter-list">
					<a v-on:click="close" v-for="entry in source.entries" class="list-link" v-bind:href="entry.url">
						<span class="list-link-name theme-background" v-bind:class="'theme-' + source.era">
							{{entry.title}}
							<span class="list-link-img-wrapper">
								<span class="list-link-img theme-loading-gradient" v-if="entry.imageCropMedium || entry.imageCropSmall">
									<picture>
										<img v-bind:src="entry.imageCropSmall" v-bind:alt="entry.title" />
									</picture>
								</span>
							</span>
						</span>
					</a>
				</div>
			</div>
			`,
			props: ['index', 'source', 'close']
		};

		var MenuPeople = {
			name: 'MenuPeople',
			template: `
			<div class="menu-content-letter">
				<h4 v-if="source.sectionTitle && source.sectionTitle !== 'null'" class="h3 content-letter-main theme-color">{{source.sectionTitle}}</h4>
				<div v-if="source.entries && source.entries.length" class="content-letter-list">
					<a v-on:click="close" v-for="entry in source.entries" class="list-link" v-bind:href="entry.url">
						<span class="list-link-name theme-background">
							{{entry.title}}
							<span class="list-link-img-wrapper list-link-img-people-wrapper">
								<span class="list-link-img list-link-img-people theme-loading-gradient" v-if="entry.imageCropMedium || entry.imageCropSmall">
									<picture>
										<img v-bind:src="entry.imageCropSmall" v-bind:alt="entry.title" />
									</picture>
								</span>
							</span>
						</span>
					</a>
				</div>
			</div>
			`,
			props: ['index', 'source', 'close']
		};

		var MenuStoriesByCategory = {
			name: 'MenuStoriesByCategory',
			template: `
			<div class="menu-content-period">
				<h4 v-if="source.sectionTitle && source.sectionTitle !== 'null'" class="h3 content-period-main theme-color" v-bind:class="'theme-' + source.era" v-bind:style="{'color': source.entries[0].CategoryColour}">{{source.sectionTitle}}</h4>

				<h5 v-if="source.sectionDescription && source.sectionDescription !== 'null'" class="stories-filter-category-description">{{source.sectionDescription}}</h5>
				
				<div v-if="source.entries && source.entries.length" class="content-period-list">

					<div class="menu-content-event" v-for="entry in source.entries">
						<div class="stories-filter-category-date">
							{{entry.displayDate}}
						</div>

						<div class="stories-filter-category-name">
							<a v-on:click="close" v-bind:href="entry.url"  class="list-link"
							>	
								<span class="list-link-name theme-background" v-bind:style="{'background-color': entry.CategoryColour}">
									{{entry.title}}

									<span class="list-link-img-wrapper">
										<span class="list-link-img theme-loading-gradient" v-if="entry.imageCropMedium || entry.imageCropSmall">
											<picture>
												<img v-bind:src="entry.imageCropSmall" v-bind:alt="entry.title" />
											</picture>
										</span>
									</span>
								</span>
							</a>
						</div>
					</div>
					
				</div>
			</div>
			`,
			props: ['index', 'source', 'close']
		};

		var MenuStoriesByDate = {
			name: 'MenuStoriesByDate',
			template: `
			<div class="menu-content-period mbtom-0">				
				<div v-if="source.entries && source.entries.length" class="content-period-list">
					<div v-for="entry in source.entries" class="stories-date-list-item">
						<a v-on:click="close" class="list-link filter-date" v-bind:href="entry.url"
						>			
							<span class="list-link-name theme-background" v-bind:style="{'background-color': entry.CategoryColour}">
								{{entry.title}}
									
								<span class="list-link-img-wrapper">
									<span class="list-link-img theme-loading-gradient" v-if="entry.imageCropMedium || entry.imageCropSmall">
										<picture>
											<img v-bind:src="entry.imageCropSmall" v-bind:alt="entry.title" />
										</picture>
									</span>
								</span>
							</span>
						</a>

						<div class="stories-date-list-detail">
							<span class="category">{{entry.CategoryName}}</span>
							<i class="dot" v-bind:style="{'background-color': entry.CategoryColour}"></i>
							<span class="date">{{entry.displayDate}}</span>	
						</div>
					</div>
					

					
				</div>
			</div>
			`,
			props: ['index', 'source', 'close']
		};

		menuInst = new Vue({
			el: '#menu',
			data: {
				showsByName: [],
				showsByYear: [],
				people: [],

				storiesByCategory: [],
				storiesByDate: [],

				showsCount: 0,
				peopleCount: 0,
				storiesCount: 0,

				loading: true,

				MenuShowsByName,
				MenuShowsByYear,
				MenuPeople,
				MenuStoriesByCategory,
				MenuStoriesByDate
			},
			components: { 'virtual-list': VirtualList },
			methods: {
				close() {
					closeMenuOverlay();
				},
				async getData() {
					const url = '/umbraco/surface/menu/index';
					const method = 'GET';
					const headers = {
						'Content-Type': 'application/json'
					};

					const response = await fetch(url, { method, headers });
					const data = await response.json();

					if (data && data.constructor === Object) {
						this.initialiseData(data);
					} else {
						this.loading = false;
					}
				},
				initialiseData(data) {
					const eraMap = {};
					const showsByName = {};
					const showsByYear = {};
					const people = {};
					const storiesByCategory = {};
					const storiesByDate = {};

					// group shows by key
					if (data.Shows !== undefined && data.Shows.length) {
						this.showsCount = data.Shows.length;

						data.Shows.forEach((show) => {
							show.year = show.year || null;

							if (show.titleKey) {
								show.titleKey = show.titleKey.toString().toUpperCase();
							}

							if (!showsByName[show.titleKey]) {
								showsByName[show.titleKey] = [];
							}

							showsByName[show.titleKey].push(show);

							if (show.yearKey && show.era) {
								eraMap[show.yearKey] = show.era;
							}

							if (show.year && show.era) {
								eraMap[show.year] = show.era;
							}

							if (!showsByYear[show.year]) {
								showsByYear[show.year] = [];
							}

							showsByYear[show.year].push(show);
						});
					}

					// convert object back to array with additional data
					this.showsByName = Object.keys(showsByName)
						.sort()
						.map((sectionKey) => {
							return {
								sectionTitle: sectionKey,
								era: eraMap[sectionKey],
								entries: showsByName[sectionKey]
							};
						});

					// reversed order
					this.showsByYear = Object.keys(showsByYear)
						.sort()
						.reverse()
						.map((sectionKey) => {
							return {
								sectionTitle: sectionKey,
								era: eraMap[sectionKey],
								entries: showsByYear[sectionKey]
							};
						});

					if (
						this.showsByYear.length &&
						(this.showsByYear[0].sectionTitle === null || this.showsByYear[0].sectionTitle === 'null')
					) {
						this.showsByYear.push(this.showsByYear.shift());
					}

					if (data.People !== undefined && data.People.length) {
						this.peopleCount = data.People.length;

						data.People.forEach((person) => {
							if (person.titleKey) {
								person.titleKey = person.titleKey.toString().toUpperCase();
							}

							if (!people[person.titleKey]) {
								people[person.titleKey] = [];
							}

							people[person.titleKey].push(person);
						});
					}

					// convert object back to array with additional data
					this.people = Object.keys(people)
						.sort()
						.map((sectionKey) => {
							return {
								sectionTitle: sectionKey,
								era: eraMap[sectionKey],
								entries: people[sectionKey]
							};
						});

					// STORIES BY CATEGORY
					if (data.Stories !== undefined && data.Stories.length) {
						this.storiesCount = data.Stories.length;

						data.Stories.sort((a, b) => {
							return a.CategorySortOrder - b.CategorySortOrder;
						});

						data.Stories.sort((a, b) => (a.title > b.title ? 1 : -1));

						data.Stories.forEach((story) => {
							if (!storiesByCategory[story.CategoryName]) {
								storiesByCategory[story.CategoryName] = [];
							}

							storiesByCategory[story.CategoryName].push(story);

							// Add extra field for Date Display
							story.dateObject = new Date(story.PostedDate);
							story.yearName = story.dateObject.getFullYear();
							story.displayDate = story.PostedDate ? formatDate(story.dateObject) : '';
						});
					}

					this.storiesByCategory = Object.keys(storiesByCategory)
						.sort()
						.map((categoryName) => {
							return {
								sectionTitle: categoryName,
								sectionDescription: storiesByCategory[categoryName][0].CategoryDescription,
								entries: storiesByCategory[categoryName]
							};
						});

					// STORIES BY DATE
					if (data.Stories !== undefined && data.Stories.length) {
						this.storiesCount = data.Stories.length;

						data.Stories.sort((a, b) => {
							return b.dateObject - a.dateObject;
						});

						data.Stories.forEach((story) => {
							if (!storiesByDate[story.yearName]) {
								storiesByDate[story.yearName] = [];
							}

							storiesByDate[story.yearName].push(story);
						});
					}

					this.storiesByDate = Object.keys(storiesByDate)
						.sort()
						.map((yearName) => {
							return {
								sectionTitle: yearName,
								entries: storiesByDate[yearName]
							};
						});

					this.loading = false;
				}
			},
			mounted() {
				initializeJs();
				this.getData();
			}
		});
	};

	const initialize = () => {
		initialiseVue();
		// initializeJs();
	};

	return {
		init: initialize,
		doClose: closeMenuOverlay
	};
})();
/* globals $ */

bravo.enews = (function () {
	'use strict';

	let modal;
	let form;
	let submitBtn;
	let spinner;
	let initialized = false;

	const openModal = (e) => {
		if (e) {
			e.preventDefault();
		}

		$(modal).modal('show');
	};

	const handleFormSubmit = () => {
		submitBtn.disabled = true;
		spinner.classList.remove('d-none');
	};

	const resetModal = () => {
		if (form) {
			form.reset();
		}

		if (submitBtn) {
			submitBtn.disabled = false;
		}

		if (spinner) {
			spinner.classList.add('d-none');
		}
	};

	const initialize = () => {
		if (initialized) {
			return;
		}

		modal = document.querySelector('#enewsModal');

		if (!modal) {
			return;
		}

		initialized = true;

		form = modal.querySelector('#enews-form');
		submitBtn = modal.querySelector('.js-enews-submit');
		spinner = submitBtn.querySelector('.spinner-border');

		document.querySelectorAll('.js-enews-open').forEach((trigger) => {
			trigger.addEventListener('click', openModal);
		});

		form.addEventListener('submit', handleFormSubmit);

		$(modal).on('hidden.bs.modal', resetModal);

		// The form posts to Wordfly as a full page navigation. This logic is to make sure the form is reset when the user returns to the page.
		window.addEventListener('pagehide', resetModal);
		window.addEventListener('pageshow', resetModal);
	};

	return {
		init: initialize
	};
})();
/* globals Vue, fetch */

bravo.search = (function () {
	'use strict';

	let jsMenuLinks;
	let logo;
	let searchBar;
	let searchInput;
	let searchForm;
	let searchButton;
	let closeButton;
	let searchInst;
	let searchEl;
	let navLogo;

	const contractSearchBar = () => {
		searchBar.classList.remove('active');
		searchInput.value = '';
		logo.classList.remove('logo-hidden');
	};

	const openSearchOverlay = (e) => {
		if (e) {
			e.preventDefault();
		}

		if (searchInst) {
			searchInst.getData(searchInput.value);
		}

		document.body.removeEventListener('click', contractSearchBar, { once: true });

		$('body').addClass('search-open');
		searchEl.fadeIn(500);

		bravo.menu.doClose();
	};

	const closeSearchOverlay = () => {
		searchEl.fadeOut(500, function () {
			if (searchInst) {
				searchInst.clearData();
			}
		});

		$('body').removeClass('search-open');
	};

	const expandSearchBar = () => {
		bravo.menu.doClose();

		searchBar.classList.add('active');
		logo.classList.add('logo-hidden');
		document.body.addEventListener('click', contractSearchBar, { once: true });

		searchInput.focus();
	};

	const doToggle = (e) => {
		e.stopPropagation();

		if (!searchBar.classList.contains('active')) {
			expandSearchBar();
		} else {
			openSearchOverlay(e);
		}
	};

	const doClose = () => {
		contractSearchBar();
		closeSearchOverlay();
	};

	const initializeJs = () => {
		searchEl = $('#search');
		logo = document.querySelector('.navbar .navbar-logo');
		searchBar = document.querySelector('.navbar-search');
		searchForm = document.querySelector('.navbar-search form');
		searchInput = document.querySelector('.navbar-search .search-input');
		searchButton = document.querySelector('.navbar-search .search-icon');
		closeButton = document.querySelector('.navbar-search .close-icon');
		jsMenuLinks = $('.search-overlay .js-menu-links');
		navLogo = $('.navbar-logo');

		if (!searchBar) {
			return;
		}

		searchInput.addEventListener('click', (e) => {
			e.stopPropagation();
		});

		searchForm.addEventListener('submit', openSearchOverlay);

		searchButton.addEventListener('click', doToggle);

		closeButton.addEventListener('click', doClose);

		navLogo.on('click', doClose);

		jsMenuLinks.each(function () {
			const link = $(this);
			link.on('click', function () {
				link
					.closest('.sidebar-links-main-content')
					.addClass('active')
					.siblings('.sidebar-links-main-content')
					.removeClass('active');

				const currentContent = $('.search-overlay .page-menu-content.active');
				const nextContent = $(link.data('target'));
				currentContent.removeClass('active');
				nextContent.addClass('active');
			});
		});
	};

	const initialiseVue = () => {
		searchInst = new Vue({
			el: '#search',
			data: {
				shows: [],
				people: [],
				stories: [],
				searchTerm: null,

				loading: false
			},
			methods: {
				close() {
					doClose();
				},
				clearData() {
					this.shows = [];
					this.people = [];
					this.stories = [];
					this.searchTerm = null;
					this.loading = false;
				},
				async getData(searchString) {
					if (searchString === this.searchTerm) {
						return;
					}

					this.loading = true;
					this.searchTerm = searchString;

					const url = '/umbraco/surface/search/index?keywords=' + searchString;
					const method = 'GET';
					const headers = {
						'Content-Type': 'application/json'
					};

					const response = await fetch(url, { method, headers });
					const data = await response.json();

					if (data && data.constructor === Object) {
						this.initialiseData(data);
					} else {
						this.loading = false;
					}
				},
				initialiseData(data) {
					if (data.Shows !== undefined && data.Shows.length) {
						this.shows = data.Shows.sort((a, b) => b.year - a.year);
					} else {
						this.shows = [];
					}

					if (data.People !== undefined && data.People.length) {
						this.people = data.People;
					} else {
						this.people = [];
					}

					if (data.Stories !== undefined && data.Stories.length) {
						this.stories = data.Stories.sort((a, b) => b.year - a.year);
					} else {
						this.stories = [];
					}

					this.loading = false;

					if (!this.shows.length) {
						if (this.people.length) {
							$('.search-overlay [data-target="#search-people"]').trigger('click');
						} else if (this.stories.length) {
							$('.search-overlay [data-target="#search-stories"]').trigger('click');
						}
					}
				}
			},
			mounted() {
				initializeJs();
			}
		});
	};

	const initialize = () => {
		initialiseVue();
	};

	return {
		init: initialize,
		doClose: doClose
	};
})();